import Swiper from "@modules/swiper";
import { Navigation, EffectFade, Keyboard, Autoplay, A11y } from "@modules/swiper/modules";

/*import '@modules/swiper/css';*/
import "@modules/swiper/modules/a11y";
import "@modules/swiper/modules/keyboard";
import "@modules/swiper/modules/navigation";
import "@modules/swiper/modules/pagination";
import '@modules/swiper/modules/effect-fade';
import $ from "@modules/jquery";


export function AutoSliderBlock(SELECTOR_BLOCK) {
    const autoBlock = document.querySelector(SELECTOR_BLOCK);
    const autoSlider = autoBlock.querySelector('.spk-auto-slider');
    if (autoSlider) {
        const swiperInstance = new Swiper(autoSlider, {
            modules: [Navigation, A11y, Keyboard, Autoplay, EffectFade],
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            a11y: {
                prevSlideMessage: SlideMessagePrev,
                nextSlideMessage: SlideMessageNext,
            },
            centeredSlides: false,
            loop: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
                pageUpDown: true,
            },
            navigation: {
                prevEl: '.arrow-left',
                nextEl: '.arrow-right',
            },
            grabCursor: true,
            on: {
                init: function () {
                    const boxes = autoSlider.querySelectorAll('.spk-auto-slider-item-box');

                    // Calculate maximum height
                    let maxHeight = 0;
                    boxes.forEach(box => {
                        const height = box.offsetHeight;
                        maxHeight = Math.max(maxHeight, height);
                    });


                    // Set the maximum height to all boxes
                    boxes.forEach(box => {
                        box.style.height = maxHeight + 'px';
                    });
                    positionArrowsBelowImage(this);

                },
                slideChange: function () {

                    positionArrowsBelowImage(this);

                },
            },

        });

        // Riferimenti ai pulsanti
        const playButton = document.querySelector('.arrow-play');
        const stopButton = document.querySelector('.arrow-stop');
        const updateButtonVisibility = () => {
            if (swiperInstance.autoplay.running) {
                playButton.style.display = 'none';
                stopButton.style.display = 'block';
            } else {
                playButton.style.display = 'block';
                stopButton.style.display = 'none';
            }
        };

        // Aggiungi evento per il pulsante "Play"
        if (playButton) {
            playButton.addEventListener('click', () => {
                swiperInstance.autoplay.start();
                updateButtonVisibility()

            });
        }

        // Aggiungi evento per il pulsante "Stop"
        if (stopButton) {
            stopButton.addEventListener('click', () => {
                swiperInstance.autoplay.stop();
                updateButtonVisibility()

            });
        }
        setTimeout(updateButtonVisibility, 0);

        function positionArrowsBelowImage(swiper) {
            const activeSlide = swiper.slides[swiper.activeIndex];
            ////console.log(activeSlide, "activeSlid");
            const image = activeSlide.querySelector("img"); // Seleziona l'immagine nella slide attiva
            ////console.log(image, "image" );
            const frecce = document.querySelector(".frecce");

            if (image && frecce) {
                // Calcola l'altezza dell'immagine dopo il caricamento
                const imageHeight = image.clientHeight;
                ////console.log(imageHeight, "imageHeight" );

                // Posiziona le frecce 30px sotto la base dell'immagine
                const newArrowPosition = imageHeight - 100;
                frecce.style.top = `${newArrowPosition}px`;
                ////console.log(newArrowPosition, "newArrowPosition" );

            }
        }
    }

}